import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo/Logo";
import { CONTACTS } from "@/constants/contacts";

export default function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <Link to="/" aria-label="Akali AI — início" data-testid="footer-logo-link">
              <Logo size={28} variant="footer" testId="footer-logo" />
            </Link>
            <p className="footer-tagline">
              O copiloto clínico do fisioterapeuta brasileiro.
            </p>
            <a
              href={`mailto:${CONTACTS.general}`}
              className="footer-link"
              data-testid="footer-contact-email"
              style={{ marginTop: 12, color: "var(--color-accent)" }}
            >
              {CONTACTS.general}
            </a>
            <p className="footer-copy">© 2026 Akali AI</p>
          </div>

          <div>
            <p className="footer-col-title">Produto</p>
            <Link to="/como-funciona" className="footer-link" data-testid="footer-link-como-funciona">
              Como funciona
            </Link>
            <Link to="/para-clinicas" className="footer-link" data-testid="footer-link-para-clinicas">
              Para clínicas
            </Link>
            <Link to="/#planos" className="footer-link" data-testid="footer-link-precos">
              Preços
            </Link>
            <Link to="/tecnologia" className="footer-link" data-testid="footer-link-tecnologia">
              Tecnologia
            </Link>
          </div>

          <div>
            <p className="footer-col-title">Empresa</p>
            <Link to="/sobre" className="footer-link" data-testid="footer-link-sobre">
              Sobre
            </Link>
            <Link to="/blog" className="footer-link" data-testid="footer-link-blog">
              Blog
            </Link>
            <Link to="/investidores" className="footer-link" data-testid="footer-link-investidores">
              Investidores
            </Link>
            <Link to="/para-clinicas#contato" className="footer-link" data-testid="footer-link-contato">
              Contato
            </Link>
          </div>

          <div>
            <p className="footer-col-title">Legal</p>
            <Link to="/privacidade" className="footer-link" data-testid="footer-link-privacidade">
              Política de Privacidade
            </Link>
            <Link to="/termos" className="footer-link" data-testid="footer-link-termos">
              Termos de Uso
            </Link>
            <Link to="/lgpd" className="footer-link" data-testid="footer-link-lgpd">
              LGPD
            </Link>
          </div>
        </div>

        <div className="footer-badges">
          <span className="compliance-pill" data-testid="badge-lgpd">
            <span style={{ width: 6, height: 6, borderRadius: 999, background: "#4CAF50" }} />
            Em conformidade com a LGPD
          </span>
          <span className="compliance-pill" data-testid="badge-coffito">
            <span style={{ width: 6, height: 6, borderRadius: 999, background: "#4CAF50" }} />
            COFFITO 414/2012
          </span>
          <span className="compliance-pill" data-testid="badge-data-br">
            <span style={{ width: 6, height: 6, borderRadius: 999, background: "#4CAF50" }} />
            Dados no Brasil
          </span>
        </div>

        <p className="footer-disclaimer">
          Ferramenta de apoio à documentação clínica. Não substitui o julgamento
          profissional. Alinhado ANVISA RDC 657/2022 e COFFITO 414/2012.
        </p>
      </div>
    </footer>
  );
}
